/* eslint-disable max-lines-per-function */
/* eslint-disable array-element-newline */
import {TemplateAPIClient} from 'extensions/template-api-client';
import {rmaInvoiceStore} from './rma-invoice-store';

export class RMAController extends EventTarget {

	/**
	 * @type {rmaInvoiceStore}
	 */
	store = rmaInvoiceStore;

	/**
	 * @type {TemplateAPIClient}
	 */
	client = new TemplateAPIClient();

	/**
	 * @param {import('extensions/rma/types').RMAState} state
	 * @returns {import('extensions/rma/types').RMARequestData}
	 */
	_translateStateToRequestData (state) {
		return {
			CustomerEmail: state?.mivaCustomerEmail,
			CustomerID: this.store?.state?.custNum,
			InvoiceNum: this.store?.state?.invoiceNum,
			MivaOrderId: state?.mivaOrderId,
			OrderNum: this.store?.state?.orderNum,
			PONum: this.store?.state?.poNum,
			PackageDimensionsHeight: state.packageHeight,
			PackageDimensionsLength: state.packageLength,
			PackageDimensionsWidth: state.packageWidth,
			PickupDate: state?.pickupDate,
			RefType: 'RMA',
			ReturnCredit: state?.total === null ? null : (Math.round(Number(state.total) * 100) / 100).toFixed(2),
			ReturnedItems: state?.productStates?.reduce((output, productState) => {
				const returnedItems = productState.returnData?.map(returnData => {

					/**
					 * @type {import('extensions/rma/types').RMARequestDataReturnedItems}
					 */
					const returnedItem = {
						ItemCondition: returnData?.itemCondition,
						LineId: productState?.lineId,
						PartNum: productState?.sku,
						PhotoData: returnData?.uploadData?.map(uploadData => uploadData.url),
						PhotoProvided: Boolean(returnData?.uploadData?.length > 0),
						Qty: 1,
						ReturnReason: returnData?.reason,
						SerialNum: returnData?.serialNumber
					};

					return returnedItem;
				});

				return output.concat(returnedItems);
			}, []),
			ShippingAddress1: state?.pickupLocation?.addr1,
			ShippingAddress2: state?.pickupLocation?.addr2,
			ShippingCity: state?.pickupLocation?.city,
			ShippingCompany: state?.pickupLocation?.comp,
			ShippingCountry: state?.pickupLocation?.cntry,
			ShippingEmail: state?.pickupLocation?.email,
			ShippingFax: state?.pickupLocation?.fax,
			ShippingFirstName: state?.pickupLocation?.fname,
			ShippingLastName: state?.pickupLocation?.lname,
			ShippingPhone: state?.pickupLocation?.phone,
			ShippingState: state?.pickupLocation?.state,
			ShippingZip: state?.pickupLocation?.zip,
			SpecialInstructions: state?.specialInstructions
		};
	}

	/**
	 * @param {number} invoiceNumber
	 * @param {boolean} forceFetch
	 * @returns {[import('../types').RMAResponse | null, string]}
	 */
	async getInvoice (invoiceNumber, forceFetch = false) {
		if (!forceFetch && this.store.state?.invoiceNum === invoiceNumber) {
			this.dispatchEvent(new CustomEvent('storage'));

			return [this.store?.state, ''];
		}

		const response = await this.client.fetch('GET_INVOICE_INFO', {
			invoice: invoiceNumber
		})
			.catch(err => {
				// eslint-disable-next-line no-console
				console.error(err);
			});

		// Set storage if response is successful
		if (response.success) {
			this.store.set(response.data);
		}
		else {
			this.store.set({});
		}

		this.dispatchEvent(new CustomEvent('http'));

		return response.success
			? [response.data, '']
			: [null, `${response.error_code}: ${response.message}`];
	}

	/**
	 * @param {import('extensions/rma/types').RMAState} state
	 */
	async sendReturnNonMiva (state) {
		const request = this._translateStateToRequestData(state);

		const response = await this.client.fetch('SEND_RETURN_NON_MIVA', {
			rma: request
		})
			.catch(err => {
				// eslint-disable-next-line no-console
				console.error(err);
			});

		return response.success
			? [response.data, '']
			: [null, `${response.error_code}: ${response.message}`];
	}

	/**
	 * @param {import('extensions/rma/types').RMAState} state
	 */
	async sendReturnMiva (state) {
		const response = await this.client.fetch('SEND_RETURN_MIVA', {
			rma: this._translateStateToRequestData(state)
		})
			.catch(err => {
				// eslint-disable-next-line no-console
				console.error(err);
			});

		return response.success
			? [response.data, '']
			: [null, `${response.error_code}: ${response.message}`];
	}
};

